import React, { useEffect } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import SessionPopupWrapper from "../../providers/NetworkProvider";
import A2HSPrompt from "../A2HSPrompt/A2HSPrompt";

const Layout = () => {
  const session_id = localStorage.getItem("session_id");
  const userIsLogIn = Boolean(session_id);

  const navigate = useNavigate();

  useEffect(() => {
    if (!session_id) {
      navigate("/start");
    }
  }, [navigate, session_id]);

  return (
    <div>
      {userIsLogIn ? (
        <SessionPopupWrapper>
          <A2HSPrompt />
          <Outlet />
        </SessionPopupWrapper>
      ) : (
        <Navigate to={"/start"} replace />
      )}
    </div>
  );
};

export default Layout;
